module.exports = __webpack_public_path__ + "static/assets/55cc714f04dc04cffc131658f81c430b.svg";